export const getTransformedMarkdown = (description: string | null | undefined) => {
	if (!description) return '';

	let transformedDescription = description;

	while (transformedDescription.includes('*[')) {
		const regex = /\*\[.*?\]/;
		transformedDescription = `${transformedDescription
			.replace(regex, (match) => {
				return '[*' + match.slice(2, -1) + '*]';
			})
			.replace(')*', ')')}`;
	}

	return transformedDescription;
};
